// extracted by mini-css-extract-plugin
export default {"home":"Home_home__spFXJ","content":"Home_content__n7yAe","heading":"Home_heading__tFinv"};